// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"94e808ec5eb41c8410ca","452":"814ca016925c5261212e","453":"c30bfbfdacd7fa2de3e0","522":"6e6d3d193b2ca04cf840","551":"31399aeab03abe38adbb"}[chunkId] + ".js";
};